module.exports = __webpack_public_path__ + "static/media/europatipset.645ae53b.svg";